import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { CircularProgress } from 'material-ui/Progress';
import Slide from 'material-ui/transitions/Slide';

import find from 'lodash/find'

import * as publish from '../../../actions/esignaturedetails';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class DeleteEsignature extends Component {

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        // this.props.closeDialog();
        this.props.actions.deleteeSignatureDetails(this.props.id);
    };

    render() {
        const { id, esignatureDetails } = this.props;
        let result = null;
        if (esignatureDetails && esignatureDetails.Status) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Delete eSignature </span>
                    </DialogTitle>
                    <DialogContent>
                        {result}
                        <div className="row p-4">
                            <div className="col-md-12">
                                Do you want to delete the eSignature Details?
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                        <Button onClick={this.setData} variant="raised" className="jr-btn bg-primary text-white">Delete</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(publish, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DeleteEsignature);


// WEBPACK FOOTER //
// ./app/esignaturedetails/esignaturelist/deleteesignature.js